export const HOST_API_KEY = import.meta.env.VITE_REACT_APP_HOST_API_KEY;